export enum DragType {
  File = 'file',
  Folder = 'folder',
}
